export default "__VITE_ASSET__74672b29__$_?nuxt_component=async__"